import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'

export class CheckSMSCodeApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'order/confirmSMSCode',
      requesterInfo,
    })
  }

  public async confirmSMSCode(request: string): Promise<any> {
    return await this.postAsync<any>(JSON.stringify(request))
  }
}
